// Wrappers for /api/v1/communications endpoints used by the POS app.
// G4.3: reorder-link generation (authed) to produce the QR payload shown on
// the bill-completion modal.

import { apiClient } from '@/lib/api-client';

export interface CreateReorderLinkPayload {
  bill_id: string;
  channel: 'WHATSAPP' | 'EMAIL';
  recipient: string;
}

export interface ReorderLinkResult {
  id: string;
  bill_id: string;
  reorder_link: string;
  channel: 'WHATSAPP' | 'EMAIL';
  status: string;
  expires_at: string;
}

export const communicationsService = {
  async createReorderLink(payload: CreateReorderLinkPayload): Promise<ReorderLinkResult> {
    return apiClient<ReorderLinkResult>('/communications/reorder-link', {
      method: 'POST',
      body: payload,
    });
  },
};
